export default {
  appName: 'Pet Care Note',
  loading: 'Loading...',
  loadingPet: 'Loading pet data...',
  error: 'Error',
  success: 'Success',
  cancel: 'Cancel',
  confirm: 'Confirm',
  save: 'Save',
  delete: 'Delete',
  edit: 'Edit',
  close: 'Close',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  submit: 'Submit',
  search: 'Search',
  filter: 'Filter',
  sort: 'Sort',
  yes: 'Yes',
  no: 'No',
  optional: 'Optional',
  required: 'Required',
  add: 'Add',
  unknown: 'Unknown',
  
  // Pet species translations
  species: {
    all: 'All Types',
    pets: 'pets',
    dog: 'Dog',
    cat: 'Cat',
    bird: 'Bird',
    fish: 'Fish',
    rabbit: 'Rabbit',
    hamster: 'Hamster',
    guinea_pig: 'Guinea Pig',
    reptile: 'Reptile',
    turtle: 'Turtle',
    other: 'Other'
  },
  
  // Pet species descriptions
  loyalCompanion: 'Loyal Companion',
  independentPartner: 'Independent Partner',
  cleverSinger: 'Clever Singer',
  peacefulWatcher: 'Peaceful Watcher',
  gentleFriend: 'Gentle Friend',
  livelySprite: 'Lively Sprite',
  wiseElder: 'Wise Elder',
  specialPartner: 'Special Partner',
  
  // Time units
  time: {
    years: 'years',
    year: 'year',
    months: 'months',
    month: 'month',
    days: 'days',
    day: 'day',
    hours: 'hours',
    hour: 'hour',
    minutes: 'minutes',
    minute: 'minute',
    today: 'Today',
    tomorrow: 'Tomorrow'
  },
  
  actions: {
    getStarted: 'Get Started',
    learnMore: 'Learn More',
    signUp: 'Sign Up',
    signIn: 'Sign In',
    signOut: 'Sign Out',
    viewDetails: 'View Details',
    addNew: 'Add New',
    add: 'Add',
    update: 'Update',
    remove: 'Remove',
    share: 'Share',
    download: 'Download',
    upload: 'Upload',
    refresh: 'Refresh',
    retry: 'Retry',
  },
  
  validation: {
    required: 'This field is required',
    invalidEmail: 'Invalid email address',
    invalidPhone: 'Invalid phone number',
    passwordTooShort: 'Password must be at least 8 characters',
    passwordsDoNotMatch: 'Passwords do not match',
    invalidDate: 'Invalid date',
    invalidUrl: 'Invalid URL',
  },
  
  messages: {
    saveSuccess: 'Saved successfully',
    deleteSuccess: 'Deleted successfully',
    updateSuccess: 'Updated successfully',
    errorOccurred: 'An error occurred',
    noData: 'No data',
    confirmDelete: 'Are you sure you want to delete?',
    unsavedChanges: 'You have unsaved changes. Are you sure you want to leave?',
    loadingPet: 'Loading pet data...',
  },
  
  errors: {
    failedToFetch: 'Failed to connect to server, please check your network connection'
  },

  seo: {
    home: {
      title: 'Pet Care Note - Comprehensive Pet Health Management System | Easy Pet Health Tracking',
      description: 'Pet Care Note helps you easily manage your pet\'s health, diet, and care plans. Track vaccinations, medications, vet visits, and supports multilingual interface (English, Chinese, Japanese). Free to use, care for your furry friend anytime, anywhere.',
      keywords: 'pet health management, pet records, pet health tracking, pet vaccination records, pet medical records, pet care, pet feeding plan, multilingual pet app'
    },
    features: {
      title: 'Features - Pet Care Note | Complete Pet Management Tools',
      description: 'Explore Pet Care Note\'s powerful features: complete pet profiles, secure sharing, health tracking, medication reminders, multilingual support, and more. Everything you need to care for your pet.',
      keywords: 'pet management features, pet health tracking, medication reminders, vet appointments, pet sharing, multilingual pet app, pet care tools'
    },
    about: {
      title: 'About Us - Pet Care Note | Our Mission & Story',
      description: 'Learn about Pet Care Note\'s mission to provide the best pet health management tools for pet owners worldwide. Explore our story and commitment to excellence in pet care.',
      keywords: 'about pet health management, pet care mission, pet health management company, pet care story, pet care team'
    },
    contact: {
      title: 'Contact Us - Pet Care Note | Get Support & Answers',
      description: 'Need help or have questions? Contact the Pet Care Note support team. We\'re here to answer any questions about pet health management, account issues, or feature requests.',
      keywords: 'contact pet health management, pet care support, customer service, help center, pet care questions, technical support'
    },
    privacy: {
      title: 'Privacy Policy - Pet Care Note | Your Data Protection',
      description: 'Read Pet Care Note\'s privacy policy to understand how we protect and handle your personal information and pet data. Your privacy and security are our top priorities.',
      keywords: 'privacy policy, data protection, pet data security, personal information, GDPR compliance, data privacy'
    },
    terms: {
      title: 'Terms of Service - Pet Care Note | User Agreement',
      description: 'View Pet Care Note\'s terms of service and user agreement. Understand your rights and responsibilities when using our pet health management platform.',
      keywords: 'terms of service, user agreement, terms and conditions, service terms, legal terms, user rights'
    },
    dashboard: {
      title: 'Dashboard - Pet Care Note | Manage Your Pets',
      description: 'Access your Pet Care Note dashboard to view and manage all your pets\' health information, schedules, and care plans in one place.',
      keywords: 'pet dashboard, pet management, pet health overview, pet care dashboard'
    },
    blog: {
      title: 'Blog - Pet Care Note | Pet Care Tips & Guides',
      description: 'Discover expert pet care advice, health tips, training guides, and the latest news about pet wellness. Stay informed with Pet Care Note\'s comprehensive blog.',
      keywords: 'pet care blog, pet health tips, pet training guides, pet wellness, pet care advice, pet nutrition, pet behavior'
    }
  }
};